import "./chunk-EZZMBBAL.js";

// src/index.ts
import { warn } from "@solid-devtools/shared/utils";
warn(`\`import "solid-devtools";\` is an entry point for the vite plugin.
If you're seeing this message you probably forgot to add the plugin to your vite config.`);
